import React from "react";
import { Link as RouterLink } from "react-router-dom";
import {
  Container,
  VStack,
  Heading,
  Text,
  Box,
  SimpleGrid,
  LinkBox,
  LinkOverlay,
} from "@chakra-ui/react";
import { brandConfig, getColor } from "../../brandConfig";
import { NavbarWithCallToAction } from "../../components/chakra/NavbarWithCallToAction/NavbarWithCallToAction";
import { FooterWithFourColumns } from "../../components/chakra/FooterWithFourColumns/FooterWithFourColumns";

interface CheatsheetCard {
  title: string;
  description: string;
  path: string;
}

const cheatsheets: CheatsheetCard[] = [
  {
    title: "SurgReady Patient Journey",
    description: "The complete patient flow from discovery to subscription, LM course, health assessment snapshots, and admin oversight.",
    path: "/cheatsheets/surgready-patient-journey",
  },
  {
    title: "Assessment & Snapshot Module",
    description: "Patient health assessments with multi-step forms, radar chart visualisation, snapshot comparison with delta tracking, and admin dashboard.",
    path: "/cheatsheets/surgready-assessment-module",
  },
];

const CheatsheetIndex: React.FC = () => {
  const bgMain = getColor("background.main");
  const textPrimary = getColor("text.primary");

  return (
    <Box bg={bgMain} minHeight="100vh" display="flex" flexDirection="column">
      <NavbarWithCallToAction />

      <Container maxW="container.lg" py={10} flex="1">
        <VStack spacing={6} align="stretch">
          <Heading size="lg" color={textPrimary}>
            SurgReady Cheatsheets
          </Heading>
          <Text color={brandConfig.colors.text.secondary} fontSize="sm">
            Visual guides for the SurgReady platform
          </Text>

          <SimpleGrid columns={{ base: 1, md: 2 }} spacing={5}>
            {cheatsheets.map((sheet) => (
              <LinkBox
                key={sheet.path}
                p={6}
                bg={brandConfig.colors.background.surface}
                borderRadius="lg"
                border="1px solid"
                borderColor={brandConfig.colors.border.light}
                _hover={{
                  borderColor: brandConfig.colors.primary,
                  shadow: "md",
                  transform: "translateY(-2px)",
                  transition: "all 0.2s",
                }}
                transition="all 0.2s"
              >
                <VStack align="start" spacing={2}>
                  <LinkOverlay as={RouterLink} to={sheet.path}>
                    <Heading size="sm" color={brandConfig.colors.primary}>
                      {sheet.title}
                    </Heading>
                  </LinkOverlay>
                  <Text fontSize="sm" color={brandConfig.colors.text.secondary}>
                    {sheet.description}
                  </Text>
                </VStack>
              </LinkBox>
            ))}
          </SimpleGrid>
        </VStack>
      </Container>

      <FooterWithFourColumns />
    </Box>
  );
};

export default CheatsheetIndex;
